// The internship recruiting cycle InternHub is currently running quests for.
//
// To roll the app over to the next cycle, change CYCLE_YEAR and nothing else --
// quest copy, the graduation-year picker, and the quest-plan date ranges all
// derive from it.
//
// CYCLE_YEAR is the year of the internship itself (2027 = "Summer 2027"
// internships), not the year applications go out. Applications for a given
// summer open the previous June/July.
export const CYCLE_YEAR = 2027;

export const CYCLE_LABEL = `Summer ${CYCLE_YEAR}`;

// Graduation years offered in the quest signup picker: the cycle year itself
// through three years out (2027-2030 for the Summer 2027 cycle).
export const SELECTABLE_GRAD_YEARS = [0, 1, 2, 3].map((offset) => CYCLE_YEAR + offset);

// Pre-selected option -- the mid-range cohort is the most common.
export const DEFAULT_GRAD_YEAR = CYCLE_YEAR + 2;

// The youngest cohort we support. Underclassman recruiting starts later and
// runs further into the spring, so quest plans treat them differently.
export const EARLY_CAREER_GRAD_YEAR = CYCLE_YEAR + 3;

// When a quest plan stops generating weekly tasks.
//
// Applications for CYCLE_YEAR summer internships run roughly June-December of
// the previous calendar year, so standard cohorts wrap up on Dec 31 of
// CYCLE_YEAR - 1. The early-career cohort keeps going to April 30 of
// CYCLE_YEAR, since underclassman programs post well into the spring.
export const getQuestEndDate = (gradYear) =>
  gradYear === EARLY_CAREER_GRAD_YEAR
    ? new Date(CYCLE_YEAR, 3, 30) // April 30, CYCLE_YEAR
    : new Date(CYCLE_YEAR - 1, 11, 31); // December 31, CYCLE_YEAR - 1
